/**
 * WARNING: The order of each item in the lists may be used in conditional statements. Add new items at the end of the
 * array in order to not introduce unwanted behavior throughout the application.
 *
 * tabName properties are used for finding tab locations. If the tabName needs to be changed, check places where the text
 * is used first, and update them as well.
 */

/**
 * Object for configuring the study view tabs, subtabs, and subtab views.
 * NOTE: If a tab does not contain subtabs, then there needs to be a 'component'
 * field at the tab level.
 */
const studyTabConfig = [
	{
		tabName: 'Track Study Progress',
		tabIcon: 'timeline',
		subTabs:
		[
			{
				tabName: 'Track Respondents',
				component: 'track-respondents'
			},
			{
				tabName: 'Track Recalls',
				component: 'track-recalls'
			}
		]
	},
	{
		tabName: 'Respondents',
		tabIcon: 'contacts',
		subTabs:
		[
			{
				tabName: 'Add new Respondents',
				component: 'new-respondents'
			},
			{
				tabName: 'View Past Respondent Files',
				component: 'past-respondents'
			},
			{
				tabName: 'Manage Respondent Accounts',
				component: 'manage-respondents'
			}
		]
	},
	{
		tabName: 'Data & Results',
		tabIcon: 'leaderboard',
		subTabs:
		[
			{
				tabName: 'Download Analysis Files',
				component: 'analysis-files'
			},
			{
				tabName: 'View Respondent Nutrition Reports',
				component: 'nutrition-reports'
			}
		]
	},
	{
		tabName: 'Edit Study',
		tabIcon: 'create',
		subTabs:
		[
			{
				tabName: 'Edit Study Basics',
				component: 'study-basics'
			},
			{
				tabName: 'Edit Study Details',
				component: 'study-details'
			},
			{
				tabName: 'Edit Study Modules',
				component: 'study-modules'
			},
			{
				tabName: 'Manage Study Staff',
				component: 'study-staff'
			},
			{
				tabName: 'Delete Study',
				component: 'study-delete'
			}
		]
	},
	{
		tabName: 'Help & Resources',
		tabIcon: 'help',
		component: 'help-resources',
		subTabs: []
	}
];

export default studyTabConfig;
